import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Modal,
  Button,
  Table,
  Badge,
} from "react-bootstrap";
import { listAgency } from "../../api/devTrainingTemplate";
import { Link } from "react-router-dom";
import ClayButton from "@clayui/button";
import ClayLayout from "@clayui/layout";

function AgencyList() {
  const [agencyList, setAgencyList] = useState([]);

  const fetcAgecyList = async () => {
    try {
      const result = await listAgency();
      console.log("Fetched agencies:", result);

      setAgencyList(result);
    } catch (error) {
      console.log("Error fetching agencies:", error);
    }
  };

  useEffect(() => {
    fetcAgecyList();
  }, []);

  return (
    <>
      <Card.Header>
        <h4>Agency List</h4>
        <ClayLayout.Col md={12} className="d-flex justify-content-end">
          <Link to="/agencyDetailTest">
            <ClayButton displayType="primary" className="mb-2 mb-md-0">
              + Add New Agency
            </ClayButton>
          </Link>
        </ClayLayout.Col>
      </Card.Header>
      <Card.Body>
        <Table responsive bordered hover size="sm" className="mt-1">
          <thead>
            <tr>
              <th>No.</th>
              <th>Agency</th>
              <th>No. Phone</th>
            </tr>
          </thead>
          <tbody>
            {agencyList.map((d, i) => (
              <tr>
                <td>{i + 1}.</td>
                <td>
                  <Link to={`/agencyDetailTest/${d.id}?viewOnly=true`}>
                    {d.agencyName}
                  </Link>
                </td>
                <td>{d.phoneNumber}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </>
  );
}

export default AgencyList;
